import './ccf-not-favorite-icon.module.scss';

import { SvgIcon,SvgIconProps } from '@mui/material';
/* eslint-disable-next-line */
export interface CcfNotFavoriteIconProps extends SvgIconProps {}
/**
 * component used to display not a favourite icon in agent state 
 * @param props - CcfNotFavoriteIconProps
 * @example - <CcfNotFavoriteIcon />
 * @returns SVG of not a favourite icon
 */
export function CcfNotFavoriteIcon(props: CcfNotFavoriteIconProps) {
  return (
    <SvgIcon {...props}>    
      <g id="ic_star_outline" clipPath="url(#clip-ic_star_outline)">
        <g
          id="Display_Favorite"
          data-name="Display Favorite"
          transform="translate(4.002 4.37)"
        >
          <path
            id="favorite"
            d="M17.979,8.215a.8.8,0,0,0-.687-.535l-4.546-.663-2.037-4.13a.8.8,0,0,0-1.438,0L7.234,7.009,2.688,7.68a.787.787,0,0,0-.447,1.342l3.3,3.2-.8,4.538a.8.8,0,0,0,1.174.863L9.99,15.485l4.074,2.133a.743.743,0,0,0,.367.1.8.8,0,0,0,.791-.951l-.8-4.538,3.3-3.2A.8.8,0,0,0,17.979,8.215Zm-4.913,3.2a.8.8,0,0,0-.232.7l.575,3.355-3-1.6a.847.847,0,0,0-.751,0l-3,1.6.575-3.355a.8.8,0,0,0-.232-.7l-2.4-2.4,3.363-.487a.8.8,0,0,0,.607-.439L9.99,5.044l1.5,3.052a.8.8,0,0,0,.607.439l3.363.487Z"
            transform="translate(-2.006 -2.436)"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfNotFavoriteIcon;
